import React, { useEffect } from "react";
import styled from "styled-components";
import about from "../images/about.svg";
import { Link, Outlet } from "react-router-dom";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import { IoLogoJavascript } from "react-icons/io";
import { BiGitBranch } from "react-icons/bi";
import { SiTailwindcss, SiStyledcomponents, SiSass } from "react-icons/si";
import { FaCss3Alt, FaReact } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";
import { SiNuxtdotjs } from "react-icons/si";
import { SiVuedotjs } from "react-icons/si";

import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import TopBanner from "../components/TopBanner";

const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const constainerVariant = {
    hidden: {
      scaleX: 0,
    },
    visible: {
      scaleX: 1,
      transition: { type: "spring", stiffness: 50 },
    },
    exit: {
      scaleX: 0,
      transition: { ease: "easeInOut" },
    },
  };

  return (
    <>
      <motion.div
        variants={constainerVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <Container>
          <TopBanner
            loaction1={"Currently"}
            location2={"Frontend Developer"}
            place1={"Based in Abuja"}
            place2={"Nigeria"}
          />

          <Main>
            <PlaceDiv data-aos="fade-left">
              <h1 data-aos="fade-left">frontend developer</h1>
              <img src={about} alt="coding" />
            </PlaceDiv>

            <Myself>
              <p data-aos="fade-left">
                I'm a self-taught frontend developer with some experience
                creating compelling web experiences and products. I look forward
                to working with individuals and teams to create memorable
                experiences for SMEs and major corporations.
                <br />
                <br />
                Each project provides an opportunity to acquire new concepts
                from a variety of disciplines, continually improve myself and
                help grow the development community.
              </p>
            </Myself>

            <Services>
              <h1 data-aos="fade-left">services</h1>

              <div>
                <ul>
                  <li data-aos="fade-left">
                    I plan, build and maintain scalable frontend web
                    applications.
                  </li>
                  <li data-aos="fade-right">
                    I help to improve the user interface of websites and web
                    applications.
                  </li>
                  <li data-aos="fade-left">
                    I build layouts and interactions optimizing for performance
                    and usabilty.
                  </li>
                </ul>
              </div>
            </Services>

            <TopBanner
              loaction1={"PERSONAL"}
              location2={"INTERESTS"}
              place1={"CLICK"}
            />

            <PersonInterests>
              <ul>
                <li data-aos="flip-right">
                  <Link to="gaming">GAMING</Link>
                </li>
                <li data-aos="flip-right" data-aos-duration="1000">
                  <Link to="music">MOVIES</Link>
                </li>
                <li data-aos="flip-right" data-aos-duration="1500">
                  <Link to="sports">SPORTS</Link>
                </li>
              </ul>

              <div className="out-div" data-aos="zoom-in">
                <Outlet />
              </div>
            </PersonInterests>
            <MyStack>
              <h2>my stack</h2>
              <div>
                <BiGitBranch />
                <AiFillHtml5 style={{ color: "#e34c26" }} />
                <AiFillGithub />
                <IoLogoJavascript style={{ color: "f7df1e" }} />
                <SiNextdotjs />
                <SiTailwindcss style={{ color: "#00d8ff" }} />
                <SiStyledcomponents style={{ color: "pink" }} />
                <SiSass style={{ color: "#cc6699" }} />
                <FaCss3Alt style={{ color: "#264de4" }} />
                <FaReact style={{ color: "#00d8ff" }} />
                <SiNuxtdotjs style={{ color: "#41b883 " }} />
                <SiVuedotjs style={{ color: "#41b883 " }} />
              </div>
            </MyStack>
          </Main>
        </Container>
      </motion.div>
    </>
  );
};

export default About;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
`;

const Main = styled.main`
  width: 100%;
`;

const PlaceDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: 8rem 0;

  h1 {
    font-size: 80px;
    text-transform: uppercase;
  }

  img {
    width: 500px;
    height: 300px;
    object-fit: contain;
    margin: 3rem 0;
    border-radius: 10px;
  }

  @media screen and (max-width: 760px) {
    margin-top: 0;

    h1 {
      font-size: 40px;
    }
  } ;
`;

const Myself = styled.div`
  width: 100%;
  height: 70vh;
  p {
    line-height: 1.32;
    font-size: 30px;
  }

  img {
    width: 350px;
    height: 350px;
    object-fit: cover;
    border-radius: 50%;
    grid-area: 2/2/3/3;
  }

  @media screen and (max-width: 760px) {
    display: block;
    margin: auto;

    h3 {
      text-align: left;
      margin-bottom: 2rem;
    }

    p {
      width: 100%;
      font-size: 20px;
      text-align: left;
    }

    img {
      margin-top: 2rem;
    }
  } ;
`;

const Services = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 80px;
    text-transform: uppercase;
    margin-bottom: 5rem;
  }

  div {
    width: 60%;
    display: block;
    margin: auto;
    text-align: center;

    ul {
      list-style: none;
      line-height: 5rem;
    }

    li {
      font-size: 25px;
      text-align: left;
      border-bottom: 1px solid black;
      margin-bottom: 3rem;
    }
  }

  @media screen and (max-width: 760px) {
    h1 {
      font-size: 40px;
      margin-top: 3rem;
    }

    div {
      width: 100%;

      ul {
        line-height: 2rem;
      }

      li {
        font-size: 22px;
        text-align: left;
        border-bottom: 1px solid black;
        margin-bottom: 3rem;
      }
    }
  }
`;

const PersonInterests = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  ul {
    width: 100%;
    display: flex;
    list-style: none;
    justify-content: center;
  }

  li {
    margin: 0 3rem;

    @media screen and (max-width: 1024px) {
      a {
        font-size: 60px;
      }
    }
    @media screen and (max-width: 1228px) {
      a {
        font-size: 50px;
      }
    }
    @media screen and (max-width: 768px) {
      margin: 0 1rem;

      a {
        font-size: 40px;
      }
    }
  }

  a {
    text-decoration: none;
    font-size: 80px;
    font-weight: bold;
    color: ${(props) => props.theme.dark.custom};
    transition: all 0.3s;
    animation: interest 1s ease-in-out;
    animation-iteration-count: infinite;

    @keyframes interest {
      0% {
        opacity: 100%;
      }
      25% {
        opacity: 75%;
      }
      50% {
        opacity: 50%;
        color: var(--custom);
      }
      75% {
        opacity: 25%;
      }
      100% {
        opacity: 100%;
      }
    }

    :hover {
      color: ${(props) => props.theme.light.neutral};
    }
  }

  .out-div {
    min-width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }

  @media screen and (max-width: 760px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    justify-content: space-evenly;

    ul {
      width: 100%;
    }

    li {
      margin: 0 0.5rem;

      a {
        text-decoration: none;
        font-size: 25px;
        font-weight: bold;
      }
    }

    .out-div {
      width: 100%;
      height: 500px;
    }
  }
`;

const MyStack = styled.div`
  width: 100%;
  padding: auto;
  margin: 0 auto;
  position: relative;
  z-index: 1;

  h2 {
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    z-index: 1;
  }

  div {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(80px, 2fr));
    justify-items: center;
    align-items: center;
    grid-gap: 1.5rem;
    margin: 2rem auto;
    padding: 1rem 0;
    z-index: 1;

    svg {
      font-size: clamp(1.5rem, 2.5rem, 3rem);
      z-index: 1;
    }
  }
`;
